const modifiedFields = ['alarmGroupName', 'alarmGroupDesc', 'tableGroupUserItems'];
const sortByFields = {
  tableGroupUserItems: ['id'],
  orderBy: ['asc']
};
const modifiedFieldCustom = {};
export default { modifiedFields, modifiedFieldCustom, sortByFields };
